import type { FaireProductEntity } from "../../entity_types/product";

export const atc_updated_fs_rec_9: FaireProductEntity = {
  token: "atc_updated_fs_rec_9",
  type: "product",
  name: "Tulip Glass Candle Holders (Set of 3)",
  brandName: "Faire Source",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/f1196b7d83a167ba84359edc676fb7aea3ac744967a5fc92a1daa2044d26f8f0.webp",
  priceDollars: 32,
  msrpDollars: 44,
  description: "Recommended product for ATC flow.",
  tags: ["home", "design", "recommendations"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
